<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useField, useForm } from 'vee-validate'
import { object, string } from 'yup'
import { useI18n } from 'vue-i18n'
import { DTextField, DBtn } from 'front-library'
import { useNotificationsStore } from '@/store/notifications'

/**
 * store y router
 */
const router = useRouter()
const store = useUserStore()

const notifications = useNotificationsStore()
const { t } = useI18n()

/**
 * Datos componente
 */
const loading = ref(false)
const wrongData = ref('')

/**
 * Datos formulario compañia
 */
const dataForgotPassword = ref({
  userEmail: ''
})

/**
 * Esquema de validacion campos obligatorios
 */
const validationSchema = object().shape({
  userEmail: string()
    .matches(
      /^[a-zA-Z0-9.-_]+@[a-zA-Z]+\.[a-zA-Z]{2,3}$/g,
      t('auth.forgotPassword.form.valid.email')
    )
    .required(t('auth.forgotPassword.form.valid.required'))
})

/**
 * Uso del metodo de validación, retorno de errores y metodo para reiniciar formulario
 */
const { handleSubmit, errors } = useForm({
  initialValues: dataForgotPassword.value,
  validationSchema
})

/**
 * Definicion de  campos del formulario
 */
const { value: userEmail } = useField<string>('userEmail')

/*
 * Metodo que valida los campos obligatorios del formulario
 */
const onSubmit = handleSubmit((values, actions) => {
  void recoveryPassword(values.userEmail)
})

/**
 * Metodo para recuperar contraseña
 */
const recoveryPassword = async (userEmail: any) => {
  loading.value = true
  console.log(userEmail)
  try {
    await store.passwordReset(userEmail).then(result => {
      console.log('passwordReset:', result)
      if (result === true) {
        wrongData.value = ''
        store.emailForgot = userEmail

        notifications.addNotification({
          title: t('Correo enviado!'), // TODO: Translate
          text: t('auth.changePassword.description'),
          type: 'success',
          time: 10000
        })
        router.push({ name: 'ChangePassword' })
      } else {
        loading.value = false
        wrongData.value = t('auth.forgotPassword.valid.limit')
      }
    })
  } catch (e: any) {
    console.error(e)
    loading.value = false
    wrongData.value = e.message
  }
}
</script>
<template>
  <h2
    class="text-3xl xl:text-4xl font-bold"
    v-text="t('auth.forgotPassword.title')" />
  <p
    class="py-3 text-gray-400 text-md md:text-lg leading-6"
    v-text="t('auth.forgotPassword.description')" />
  <div
    v-if="wrongData"
    class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4"
    role="alert">
    <p class="text-sm font-bold">{{ wrongData }}</p>
  </div>
  <form class="grid" @submit.prevent="onSubmit">
    <div class="grid mb-3">
      <DTextField
        :label="t('auth.forgotPassword.form.email')"
        type="email"
        :error="errors.userEmail"
        :placeholder="t('auth.forgotPassword.form.placeholder.email')"
        :required="true"
        v-model="userEmail" />
    </div>
    <DBtn
      class="font-semibold py-3 text-base"
      :loading="loading"
      :color="errors.userEmail == null && userEmail != '' ? 'blue' : 'disabled'"
      :disabled="errors.userEmail == null && userEmail != '' ? false : true">
      {{ t('auth.forgotPassword.send') }}
    </DBtn>
  </form>
  <div class="flex justify-between pt-4 pb-6">
    <p>{{ t('auth.forgotPassword.havePassword') }}</p>
    <a
      @click="() => router.replace({ name: 'Login' })"
      class="text-blue-600 hover:text-blue-500 font-bold cursor-pointer">
      {{ t('auth.forgotPassword.logIn') }}
    </a>
  </div>
</template>
